import { render } from "./UsluSayi.vue?vue&type=template&id=4ece9ed2"
import script from "./UsluSayi.vue?vue&type=script&lang=js"
export * from "./UsluSayi.vue?vue&type=script&lang=js"

import "./UsluSayi.vue?vue&type=style&index=0&id=4ece9ed2&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__